/* External */
import {
  memo, useCallback, useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
/* Assets */
import Icon from '~/assets/theme/svg/icon-exit-app.svg';
/* Components */
import Modal from '../Modal';
import CotentLeaveModal from './CotentLeaveModal';
/* Utils */
import {
  WANT_TO_LEAVE_TEXT,
} from '../../utils/constants';
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import {
} from '../../utils/profiles';
/* Other */
import { hideModal, showModal } from '../../storage/modal';
import { selectShowModal } from '../../storage/modal/selectors';
/* Styles */
import './WantToLeaveModal.scss';

function WantToLeaveModal({ setCountBackButton, handleExit }) {
  const dispatch = useDispatch();
  const isModalShown = useSelector(selectShowModal);
  const handleCloseModal = useCallback(() => {
    setCountBackButton(0);
    dispatch(hideModal());
  }, [dispatch, setCountBackButton]);
  const handleExitApp = useCallback(() => {
    handleExit();
    setTimeout(() => {
      setCountBackButton(0);
      dispatch(hideModal());
    }, 1000);
  }, [handleExit, setCountBackButton, dispatch]);
  const { title, buttonLeave, buttonNotNow } = WANT_TO_LEAVE_TEXT()?.modal || {};
  useEffect(() => {
    dispatch(showModal());
  }, [dispatch]);
  return (
    <Modal
      isModalShown={isModalShown}
      backgroundOpacity
    >
      <CotentLeaveModal
        icon={Icon}
        title={title}
        buttonLeave={buttonLeave}
        buttonNotNow={buttonNotNow}
        isModalShown={isModalShown}
        onEnterPress={handleCloseModal}
        onExitAppPress={handleExitApp}
      />
    </Modal>
  );
}
WantToLeaveModal.propTypes = {
  setCountBackButton: PropTypes.func.isRequired,
  handleExit: PropTypes.func.isRequired,
};
export default memo(withInteractiveFocusable()(memo(WantToLeaveModal)));
